<template>
	<div class="focusenterprises" >
		<leftnav class="fl" mkcode="E" itemcode="E-MBQY" :mkopen="true"></leftnav>
		<div class="index_left" :style="isCollapse?'margin-left: 0;width:100%':''">
			<govheader></govheader>
			<div class="index_left_centerpage">
				<div class="heightVh95 whitebox container-flex-center">
					<freeUserTips :type="4" :bgtype="0" isShowPageTitle="目标企业库"></freeUserTips>
				</div> 
			</div>
		</div>
	</div>
</template>

<script>
	import { mapState, mapMutations, mapGetters } from "vuex";
	export default {
		name: 'mapserch',
		computed: {
		...mapState({
		// isCollapse: (state) => state.app.isCollapse,
		isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
		},
		data() {
			return {
				title:"目标企业库", 
				userdata:{},curWebsite:this.$api.getWebsiteType(),  	collectPageType:13,collecttype:13,tabbtn: 0, 	shortListNum:0,longListNum: 0,
				orderField: 16, //排序字段 16 招商算法分数 1 时间
				orderType: 0, //排序方式 0 降序 1 升序 
			//龙头企业 1， 创新企业 2， 投资机构3，研究院4，资讯：5，专题：6，产业链：7，事件链：8，政策链：9，优质企业10，普通企业11，园区12，上市公司13， 
				tabtitle: [
				{name:'上市公司',tipsname:"企业",ctype:13,num:0,list:[]},
				{name:'龙头企业',tipsname:"企业",ctype:1, num:0,list:[]}, 
				{name:'创新企业',tipsname:"企业",ctype:2,num:0,list:[]},
				{name:'优质企业',tipsname:"企业",ctype:10,num:0,list:[]},
				{name:'外资企业',tipsname:"外资企业",ctype:16,num:0,list:[]},
				{name:'境外上市企业',tipsname:"境外上市企业",ctype:18,num:0,list:[]},
				{name:'投资机构',tipsname:"投资机构",ctype:3,num:0,list:[]},
				{name:'科研机构',tipsname:"科研机构",ctype:4,num:0,list:[]}, 
				{name:'产业园区',tipsname:"产业园区",ctype:12,num:0,list:[]},
				{name:'协会',tipsname:"协会",ctype:14,num:0,list:[]},
				{name:'商会',tipsname:"商会",ctype:15,num:0,list:[],},
				{name:'专业镇',tipsname:"专业镇",ctype:19,num:0,list:[],}, 
				// {name:'产业链',tipsname:"产业链",ctype:7,num:0,list:[],}, 
				], //1,2,3,4{name:'科研机构',tipsname:"科研机构",ctype:4,num:0,list:[]},
			 yuanquTabName:"&上市公司&龙头企业&创新企业&优质企业&外资企业&投资机构&科研机构",
				xindaiTabName:"&上市公司&龙头企业&创新企业&优质企业&外资企业&投资机构&境外上市企业",
				touziTabName:"&创新企业&优质企业&上市公司&龙头企业&境外上市企业&外资企业&投资机构&科研机构&产业园区",
				mapdata:[{name:"广东",value:20,data:[{name:"深圳市",value:15}]},{name:"北京",value:50,data:[{name:"朝阳区",value:30}]},],flag:false,
				// 0=分数,1=融资时间,2=企业实力,3=投资力度,4=本省关联度,5=拿地数量,6=拿地面积,7=拿地金额,8=投资项目数量,9=投资项目金额,10=控制企业数量,11=专利数量 16=招商算法总分
				dimensionList: [{
					name: '综合',
					type: 0
				}, {
					name: '融资时间',
					type: 1
				},{
					name: '企业实力',
					type: 2
				}, {
					name: '投资力度',
					type: 3
				}, {
					name: '本省关联度',
					type: 4
				}, {
					name: '拿地数量',
					type: 5
				}, {
					name: '拿地面积',
					type: 6
				}, {
					name: '拿地金额',
					type: 7
				}, {
					name: '投资项目数量',
					type: 8
				}, {
					name: '投资项目金额',
					type: 9
				},], 
				dimesmlist:[{
					name: '总体评分',
					type: 16
				}, {
					name: '企业实力',
					type: 2
				}, {
					name: '投资力度',
					type: 3
				}, {
					name: '拿地数量',
					type: 5
				}, {
					name: '拿地面积',
					type: 6
				}, {
					name: '投资项目数量',
					type: 8
				}, {
					name: '投资项目金额',
					type: 9
				},],
				enternum:0,
				// ,{name:'控制企业数量',type:10},{name:'专利数量',type:11},{name:'营业收入（亿元）',type:12},{name:'营收增速',type:13},{name:'净利润（亿元）',type:14},{name:'净利增速',type:15},
				
				// collecttype: [{
				// 	name: "产业机会",
				// 	type: 0
				// }, {
				// 	name: '龙头企业',
				// 	type: 1
				// }],
				chainlist: [],
				entercommlist:[],
				shortenterlist:[],//短名单
				academylist: [], //创新资源
				orglist: [], //投资机构
				topiclist: [], //专题 
				eventchain: [], //事件链
				policychain: [], //政策链 
				parkdata:[],//产业园区
				associationData:[],//协会
				commerceDate:[],//商会
				forcapenterlist:[],//外资企业
				foreignEnterList:[],//境外上市企业
				townlist:[],//专业镇
				tipstext: '企业',
				tipsnum: 0,
			}
		},
		created() { 
		},
		mounted() {  
		},
		methods: { 
			//页面短名单和长名单切换
			collectPageToggle(type){
				this.collectPageType=type;
				if(type == 'shortlist'){
					this.getcollectlist(this.collectPageType);
				}else{
					this.getcollectlist(this.collectPageType,this.tabbtn);
				}
				
			},
			//tab栏切换
			tabbtnfun(list,index){
				if(this.collecttype!=list.ctype){
						this.tabbtn=index;this.collecttype=list.ctype;
					 if(list.ctype==1 || list.ctype==2 || list.ctype==10 || list.ctype==13 || list.ctype==16){ 
							this.tipsnum=this.enternum; 
						}else{ 
							// if(list.ctype==99){ 
							// }
								this.tipsnum=list.num;  
						};
						this.getcollectlist(list.ctype,index);
						this.tipstext=list.tipsname;
				} 
			},
			//时间/分数升降序
			tablesort(field) {
				if (field == this.orderField) {
					this.orderType = Math.abs(this.orderType - 1);
				} else {
					this.orderField = field;
				}
				this.getcollectlist(this.collectPageType,this.tabbtn);
				// this.ajaxsearchcompany();
			},
			//获取各种类型的收藏列表
			getcollectlist(type,indexd) {
					// console.log('获取各种类型的收藏列表',type); 
				this.bus.$emit('loading',true); 
				var _this = this;var tabind=this.tabbtn;
				if(type == 'shortlist'){
					var ajaxurl = this.$api.cyl.collect.list() + '?shortList=1&pageSize=50&page=1&orderField='+this.orderField+'&orderType='+this.orderType; 
					this.$axios.get(ajaxurl, {
						headers: {AuthToken: this.userdata.token}
					}).then(function(res) { 
						if (res.data.success) {
							var enterlist = res.data.list ? res.data.list : [];  
					  _this.shortenterlist=enterlist;
							_this.shortListNum=enterlist.length;
							_this.bus.$emit('loading',false); 
						} else {
							
						}
					}).catch(function(error) {
						// console.log('错误',error);//请求失败处理 
					}); 
					
				}else {
					var ajaxurl = this.$api.cyl.collect.list() + '?type=' + type + '&pageSize=50&page=1&orderField='+this.orderField+'&orderType='+this.orderType;
				 
					this.$axios.get(ajaxurl, {
						headers: {AuthToken: this.userdata.token}
					}).then(function(res) {
						// console.log(type,res.data); 
						if (res.data.success) {
							var enterlist=[];
							if(res.data.list!=null){
								var enterlist = res.data.list.filter(list=>{
									return list.collectId>0;
								}); 
							}  
							_this.bus.$emit('loading',false);    
							let numarr=res.data.data,enterlistNum=0; //存储tab数值
							for(var i=0;i<numarr.length;i++){ 
								// if(numarr[i].type != 11){
								// 	 enterlistNum+=numarr[i].count; //长名单企业总数 type=11不知道是什么 剔除
								// }  
								for(var d=0;d<_this.tabtitle.length;d++){
									if(numarr[i].type == _this.tabtitle[d].ctype){
										_this.tabtitle[d].num=numarr[i].count;
										enterlistNum+=numarr[i].count;
									} 
								} 
							}
							_this.shortListNum=res.data.extend;
							_this.longListNum=enterlistNum;
							// _this.tabtitle[0].num=res.data.extend;
							if (type == 7) {
								_this.chainlist = enterlist;
							} else if (type == 1 || type == 2 || type == 13 || type == 10) { 
						 
								if(type !=16 && type != 18){
									_this.tabtitle[indexd].list=enterlist;
								} 
							}else if(type == 3){
								_this.orglist = enterlist;
							}else if(type == 4){
								for (var i = 0; i < enterlist.length; i++) {
									enterlist[i].notionlist = _this.taglistfun(enterlist[i].notion, enterlist[i].notionCode);
									enterlist[i].taglist = _this.taglistfun(enterlist[i].tag, enterlist[i].tagCode); 
								} 
								_this.academylist = enterlist;
							} else if (type == 6) {
								_this.topiclist = enterlist;
							} else if (type == 8) {
								_this.eventchain = enterlist;
							} else if (type == 9) {
								_this.policychain = enterlist;
							} else if(type  == 12){
								_this.parkdata=enterlist;
							}else if (type == 14){
								_this.associationData=enterlist;
							}else if(type == 15){
								_this.commerceDate=enterlist;
							}else if (type == 16){ 
								_this.forcapenterlist=enterlist;  
							}else if(type == 18){ 
								_this.foreignEnterList=enterlist;
							}else if(type == 19){
								_this.townlist=enterlist; 
							}
							console.log(type,'原始',res.data)
							console.log('筛选后',enterlist)
							// console.log(_this.tipstext,type,enterlist)
							_this.bus.$emit('loading',false); 
						} else {
							
						}
					}).catch(function(error) {
						// console.log('错误',error);//请求失败处理 
					});
				}
   // console.log(this.tabtitle)
			},
			//取消收藏
			cancelcollect(id,list,enterpriseType) { 
				// console.log(id.list)
				var _this = this; 
				var tabdg=this.tabtitle[this.tabbtn];
				// console.log(list); 
				$.ajax({
					type: "POST",
					url: this.$api.cyl.collect.remove(),
					data: {
						collectId: id
					},
					headers: {
						AuthToken: this.userdata.token
					},
					success: function(res) {
						if (res.success) {
							list.collectId=0;
							tabdg.num=tabdg.num-1;
							_this.$message({type:'success',message:"已取消对该企业的关注"});
						 
						}
					}
				})
			}, 
			//加入移除短名单
			shortlistToggle(collectid,shorttype,list){ 
				var ajaxurl=""
				if(shorttype<1){
					ajaxurl=this.$api.cyl.collect.addshortList() 
				}else if(shorttype == 1){
						ajaxurl=this.$api.cyl.collect.removeshortList() 
				}
				var _this = this;
				$.ajax({
					type: "POST",
					url: ajaxurl,
					data: {
						collectId: collectid
					},
					headers: {
						AuthToken: this.userdata.token
					},
					success: function(res) {
						if (res.success) {
						 // console.log(123,res.data);
							if(_this.collectPageType == 'shortlist'){
								list.collectId=0;
							}else{
								list.shortList=Math.abs(shorttype-1); 
								// if(shorttype<1){
								// 	_this.tabtitle[0].num=_this.tabtitle[0].num+1;
								// }else{
								// 	_this.tabtitle[0].num=_this.tabtitle[0].num-1;
								// } 
							}
							_this.$message({type:'success',message:"操作成功"})
					 
						}
					}
				})
			},
			//加入移除项目管理
			crmtoggle(data,enterpiseid){
				// console.log(data);
				var _this=this;  
				if(data.crmId ==0){ 
				this.$axios.get(this.$api.crm.enterprise.addtoCRM()+"?stockCode="+enterpiseid,{headers:{AuthToken:this.userdata.token}}).then(function(res){
					console.log("添加到CRM库",res);   
					if(res.data.success){  
							data.crmId = res.data.data.id;
						_this.$message({
							type: 'success',
							message: '已加入项目管理',
						});
					} 
				}).catch(function (error) {
					// 请求失败处理 console.log(error);
				});
				}else{
					 console.log('移除',data.crmId)
					$.ajax({
						type:"POST",
						url:this.$api.crm.customer.delete(),
						data:{id:data.crmId}, 
						headers:{AuthToken:this.userdata.token },
						success:function(res){ 
							console.log(res) 
							if(res.success){
								data.crmId = 0; 
								_this.$message({
									type: 'success',
									message: '已移除项目管理',
								});
							}else{
								_this.$message({type:"error",message:res.msg})
							}
						} 
					}) 
				}
			},
 
			
		},
	}
</script>

<style>

</style>
